import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getParamsFromHash } from 'core/utils/helpers/getParamsFromHash';
import List from 'core/modules/Partials/List/List';
import { useCarouselApi } from 'core/modules/Partials/Carousel/hooks';

import config from './configs';

import './TabNavigationTitles.scss';

function TabNavigationTitles({ setActiveTabLink, tabNavigation }) {
  const { onCarouselApiReady, carouselApi } = useCarouselApi();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const { carousel } = config;

  const findActiveTabIndexFromHash = (location, tabNavigation) => {
    const { subpage: activeTabLink = '' } = getParamsFromHash(location.hash);
    const activeTabIndex = tabNavigation.findIndex(title => title.link === activeTabLink);

    return activeTabIndex;
  };

  const handleActiveTab = () => {
    const activeTabIndex = findActiveTabIndexFromHash(location, tabNavigation);
    let activeTabLink;

    if (activeTabIndex >= 0) {
      activeTabLink = tabNavigation[activeTabIndex].link;
      carouselApi?.scrollTo(activeTabIndex, true);
      setActiveTabIndex(activeTabIndex);
    } else {
      activeTabLink = tabNavigation[0].link;
      navigate(`#subpage=${activeTabLink}`);
    }

    setActiveTabLink(activeTabLink);
  };

  const handleClick = (tab, index) => () => {
    setActiveTabIndex(index);

    setTimeout(() => {
      carouselApi?.scrollTo(index);
      navigate(`#subpage=${tab.link}`);
      setActiveTabLink(tab.link);
    }, 0);
  };

  useEffect(() => {
    if (carouselApi) {
      handleActiveTab();
    }
  }, [carouselApi]);

  return (
    <List
      shouldUseCarousel
      options={carousel}
      className="mn_tabNavigationTitles"
      onCarouselApiReady={onCarouselApiReady}
    >
      {tabNavigation.map((tab, index) => (
        <div
          className={`mn_tabTitle ${activeTabIndex === index ? 'mn_isActiveTabTitle' : ''}`}
          key={tab.id}
          tabIndex="0"
          role="button"
          data-test={`tab-navigation-title-${tab.id}`}
          onClick={handleClick(tab, index)}
        >
          <span>{tab.title}</span>
        </div>
      ))}
    </List>
  );
}

export default TabNavigationTitles;
